import PropTypes from 'prop-types';
import { AuthContext } from 'src/auth/context/authContext';
// components
import { SplashScreen } from 'src/components/loading-screen';
//

// ----------------------------------------------------------------------

export function AuthConsumer({ children }) {
  return (
    <AuthContext.Consumer>
      {(auth) => (auth.loading ? <SplashScreen /> : children)}
    </AuthContext.Consumer>
  );
}

AuthConsumer.propTypes = {
  children: PropTypes.node,
};
